export default __webpack_public_path__ + "static/media/ranch.c3336a9d.jpg";